'use strict';

exports.__esModule = true;
var FILTERS = exports.FILTERS = {
  TOGGLE_CALENDAR: 'TOGGLE_CALENDAR',
  TOGGLE_FILTER_DROPDOWN: 'TOGGLE_FILTER_DROPDOWN',
  TOGGLE_DATE_DROPDOWN: 'TOGGLE_DATE_DROPDOWN',
  CLOSE_ALL_DROPDOWNS: 'CLOSE_ALL_DROPDOWNS'
};

var toggleCalendar = exports.toggleCalendar = function toggleCalendar(payload) {
  return {
    type: FILTERS.TOGGLE_CALENDAR,
    payload: payload
  };
};

var toggleFilterDropdown = exports.toggleFilterDropdown = function toggleFilterDropdown(payload) {
  return {
    type: FILTERS.TOGGLE_FILTER_DROPDOWN,
    payload: payload
  };
};

var toggleDateDropdown = exports.toggleDateDropdown = function toggleDateDropdown(payload) {
  return {
    type: FILTERS.TOGGLE_DATE_DROPDOWN,
    payload: payload
  };
};

var closeDropdowns = exports.closeDropdowns = function closeDropdowns() {
  return {
    type: FILTERS.CLOSE_ALL_DROPDOWNS
  };
};